import { gs1CheckDigit } from '@erp/shared-utils';

export type UpcProblem = 'check-digit';

const DIGITS = /^\d+$/;
const SLASH_RUN = /^\/+$/;
const COMBINED_CHECK_LENGTH = 12;

function digitPart(value: string | null): string | null {
  if (value === null) return null;
  if (SLASH_RUN.test(value)) return null;
  if (!DIGITS.test(value)) return null;
  return value;
}

export function upcProblem(
  manufacturer: string | null,
  item: string | null,
): UpcProblem | null {
  const mftr = digitPart(manufacturer);
  const itemPart = digitPart(item);
  if (mftr === null || itemPart === null) return null;
  const combined = mftr + itemPart;
  if (combined.length !== COMBINED_CHECK_LENGTH) return null;
  const expected = gs1CheckDigit(combined.slice(0, COMBINED_CHECK_LENGTH - 1));
  return combined[COMBINED_CHECK_LENGTH - 1] === expected
    ? null
    : 'check-digit';
}
